var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 6C9.3125 6 9.25 6.09375 9.25 6.21875L9.46875 12.3438C9.46875 12.4375 9.5625 12.5 9.65625 12.5H10.3125C10.4062 12.5 10.5 12.4375 10.5 12.3438L10.7188 6.21875C10.7188 6.09375 10.6562 6 10.5312 6H9.4375ZM10 13.125C9.5 13.125 9.125 13.5312 9.125 14C9.125 14.5 9.5 14.875 10 14.875C10.4688 14.875 10.875 14.5 10.875 14C10.875 13.5312 10.4688 13.125 10 13.125ZM18.7812 14.75L11.2812 1.75C10.7188 0.75 9.25 0.75 8.6875 1.75L1.1875 14.75C0.625 15.75 1.34375 17 2.5 17H17.5C18.625 17 19.375 15.75 18.7812 14.75ZM17.5 16H2.5C2.09375 16 1.875 15.5938 2.0625 15.25L9.5625 2.25C9.75 1.9375 10.2188 1.9375 10.4062 2.25L17.9062 15.25C18.125 15.5938 17.875 16 17.5 16Z",
    fill: "#FFC41C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/WarningTriangle.7caa1115b20130a4a2105d3a57a6fabb.svg";
export { ForwardRef as ReactComponent };